import * as React from 'react';
import * as ReactDOM from 'react-dom';
import FlexSetPage from './flexSets/flexSetPage';

function hydrateCategoryPage() {
    if (typeof window.__PRELOADED_FLEXSET_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_FLEXSET_PAGE_STATE__));
        delete window.__PRELOADED_FLEXSET_PAGE_STATE__;
        ReactDOM.hydrate(
            <FlexSetPage {...data} suppressHydrationWarning />,
            document.getElementById('ats-categorypage'),
        );
    }
}

hydrateCategoryPage();
